import {
  CtoStatus,
  SceStatusList,
  ScesByRiskMahsProps,
  TagsResponse,
  WonosStatusResponse,
} from "../../../types";

export const orderByCtosDesc: SceStatusList[] = [
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
    ],
    sce_code: "Client SCE",
    sce_name: "Client SCE",
    sce_status_code: 10,
    sce_status_color: "RED",
    sce_status_label: "Critical",
    tags_status_list: [
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 81,
      },
    ],
    ctos_qty: 25,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
    ],
    sce_code: "Client TIA",
    sce_name: "Client TIA plan",
    sce_status_code: 0,
    sce_status_color: "ORANGE",
    sce_status_label: "Degraded",
    tags_status_list: [
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
    ],
    ctos_qty: 21,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-05",
    sce_name: "Temporary Refuge",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 2,
      },
    ],
    ctos_qty: 10,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
    ],
    sce_code: "DC-01",
    sce_name: "Pressure Relief",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 170,
      },
    ],
    ctos_qty: 9,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-01",
    sce_name: "Emergency Communications",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 833,
      },
    ],
    ctos_qty: 9,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
    ],
    sce_code: "DC-07",
    sce_name: "Ignition Control",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 28,
      },
    ],
    ctos_qty: 8,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
    ],
    sce_code: "DC-05",
    sce_name: "Emergency Depressurization (Blowdown) System",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 37,
      },
    ],
    ctos_qty: 6,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-04",
    sce_name: "Emergency Escape Lighting",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 962,
      },
    ],
    ctos_qty: 6,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
    ],
    sce_code: "DC-02",
    sce_name: "Vent and Flare System",
    sce_status_code: 0,
    sce_status_color: "ORANGE",
    sce_status_label: "Degraded",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 40,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 4,
      },
    ],
    ctos_qty: 4,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
    ],
    sce_code: "DC-06",
    sce_name: "Bunding and Open Hazardous Drains",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 1,
      },
    ],
    ctos_qty: 4,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-02",
    sce_name: "Escape and Evacuation Routes",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 93,
      },
    ],
    ctos_qty: 4,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-03",
    sce_name: "Emergency Power",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 4,
      },
    ],
    ctos_qty: 3,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
    ],
    sce_code: "Client HSEMS",
    sce_name: "Client HSEMS",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 54,
      },
    ],
    ctos_qty: 2,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
    ],
    sce_code: "DC-03",
    sce_name: "Fire and Gas Detection",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 778,
      },
    ],
    ctos_qty: 1,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "DC-04",
    sce_name: "Emergency Shutdown System",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 237,
      },
    ],
    ctos_qty: 0,
  },
];

export const orderByCtosAsc: SceStatusList[] = [
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "DC-04",
    sce_name: "Emergency Shutdown System",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 237,
      },
    ],
    ctos_qty: 0,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
    ],
    sce_code: "DC-03",
    sce_name: "Fire and Gas Detection",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 778,
      },
    ],
    ctos_qty: 1,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
    ],
    sce_code: "Client HSEMS",
    sce_name: "Client HSEMS",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 54,
      },
    ],
    ctos_qty: 2,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-03",
    sce_name: "Emergency Power",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 4,
      },
    ],
    ctos_qty: 3,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
    ],
    sce_code: "DC-02",
    sce_name: "Vent and Flare System",
    sce_status_code: 0,
    sce_status_color: "ORANGE",
    sce_status_label: "Degraded",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 40,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 4,
      },
    ],
    ctos_qty: 4,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
    ],
    sce_code: "DC-06",
    sce_name: "Bunding and Open Hazardous Drains",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 1,
      },
    ],
    ctos_qty: 4,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-02",
    sce_name: "Escape and Evacuation Routes",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 93,
      },
    ],
    ctos_qty: 4,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
    ],
    sce_code: "DC-05",
    sce_name: "Emergency Depressurization (Blowdown) System",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 37,
      },
    ],
    ctos_qty: 6,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-04",
    sce_name: "Emergency Escape Lighting",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 962,
      },
    ],
    ctos_qty: 6,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
    ],
    sce_code: "DC-07",
    sce_name: "Ignition Control",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 28,
      },
    ],
    ctos_qty: 8,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
    ],
    sce_code: "DC-01",
    sce_name: "Pressure Relief",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 170,
      },
    ],
    ctos_qty: 9,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-01",
    sce_name: "Emergency Communications",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 833,
      },
    ],
    ctos_qty: 9,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-05",
    sce_name: "Temporary Refuge",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 2,
      },
    ],
    ctos_qty: 10,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
    ],
    sce_code: "Client TIA",
    sce_name: "Client TIA plan",
    sce_status_code: 0,
    sce_status_color: "ORANGE",
    sce_status_label: "Degraded",
    tags_status_list: [
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
    ],
    ctos_qty: 21,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
    ],
    sce_code: "Client SCE",
    sce_name: "Client SCE",
    sce_status_code: 10,
    sce_status_color: "RED",
    sce_status_label: "Critical",
    tags_status_list: [
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 81,
      },
    ],
    ctos_qty: 25,
  },
];

export const orderByLengthDesc: ScesByRiskMahsProps[] = [
  {
    linked_mahs_list: [
      "MAH-01b(S)",
      "MAH-02b",
      "MAH-03a",
      "MAH-03c",
      "MAH-04a",
      "MAH-04b",
      "MAH-04c",
      "MAH-04d",
      "MAH-04e",
      "MAH-04f",
      "MAH-05a",
      "MAH-06a",
      "MAH-06b",
      "MAH-06d",
      "MAH-06e",
      "MAH-07b",
      "MAH-08b",
      "MAH-09a",
      "MAH-09b",
    ],
    sce_status_code: 10,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 199,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 19,
      },
    ],
  },
  {
    linked_mahs_list: [
      "MAH-01b(S)",
      "MAH-02b",
      "MAH-03a",
      "MAH-03c",
      "MAH-04a",
      "MAH-04b",
      "MAH-04c",
      "MAH-04d",
      "MAH-04e",
      "MAH-04f",
      "MAH-05a",
      "MAH-06a",
      "MAH-06b",
      "MAH-06d",
      "MAH-06e",
      "MAH-07b",
      "MAH-08b",
      "MAH-09a",
      "MAH-09b",
    ],
    sce_status_code: 10,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 198,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 19,
      },
    ],
  },
  {
    linked_mahs_list: [
      "MAH-01a(S)",
      "MAH-01b(S)",
      "MAH-04a",
      "MAH-04e",
      "MAH-04f",
      "MAH-07a",
      "MAH-08a",
    ],
    sce_status_code: -1,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 199,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 1,
      },
    ],
  },
  {
    linked_mahs_list: [
      "MAH-01a(S)",
      "MAH-01b(S)",
      "MAH-04a",
      "MAH-04e",
      "MAH-04f",
      "MAH-07a",
      "MAH-08a",
    ],
    sce_status_code: -1,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 199,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 14,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 2,
      },
    ],
  },
  {
    linked_mahs_list: ["MAH-01a(S)"],
    sce_status_code: 10,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 50,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 1,
      },
    ],
  },
  {
    linked_mahs_list: ["MAH-01a(S)"],
    sce_status_code: 10,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 51,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 2,
      },
    ],
  },
  {
    linked_mahs_list: [],
    sce_status_code: 0,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 19,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 1,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 0,
      },
    ],
  },
];

export const orderByLengthAsc: ScesByRiskMahsProps[] = [
  {
    linked_mahs_list: [],
    sce_status_code: 0,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 19,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 1,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 0,
      },
    ],
  },
  {
    linked_mahs_list: ["MAH-01a(S)"],
    sce_status_code: 10,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 50,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 1,
      },
    ],
  },
  {
    linked_mahs_list: ["MAH-01a(S)"],
    sce_status_code: 10,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 51,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 2,
      },
    ],
  },
  {
    linked_mahs_list: [
      "MAH-01a(S)",
      "MAH-01b(S)",
      "MAH-04a",
      "MAH-04e",
      "MAH-04f",
      "MAH-07a",
      "MAH-08a",
    ],
    sce_status_code: -1,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 199,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 1,
      },
    ],
  },
  {
    linked_mahs_list: [
      "MAH-01a(S)",
      "MAH-01b(S)",
      "MAH-04a",
      "MAH-04e",
      "MAH-04f",
      "MAH-07a",
      "MAH-08a",
    ],
    sce_status_code: -1,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 199,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 14,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 2,
      },
    ],
  },
  {
    linked_mahs_list: [
      "MAH-01b(S)",
      "MAH-02b",
      "MAH-03a",
      "MAH-03c",
      "MAH-04a",
      "MAH-04b",
      "MAH-04c",
      "MAH-04d",
      "MAH-04e",
      "MAH-04f",
      "MAH-05a",
      "MAH-06a",
      "MAH-06b",
      "MAH-06d",
      "MAH-06e",
      "MAH-07b",
      "MAH-08b",
      "MAH-09a",
      "MAH-09b",
    ],
    sce_status_code: 10,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 199,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 19,
      },
    ],
  },
  {
    linked_mahs_list: [
      "MAH-01b(S)",
      "MAH-02b",
      "MAH-03a",
      "MAH-03c",
      "MAH-04a",
      "MAH-04b",
      "MAH-04c",
      "MAH-04d",
      "MAH-04e",
      "MAH-04f",
      "MAH-05a",
      "MAH-06a",
      "MAH-06b",
      "MAH-06d",
      "MAH-06e",
      "MAH-07b",
      "MAH-08b",
      "MAH-09a",
      "MAH-09b",
    ],
    sce_status_code: 10,
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 198,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 19,
      },
    ],
  },
];

export const orderBySceAsc: SceStatusList[] = [
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
    ],
    sce_code: "DC-06",
    sce_name: "Bunding and Open Hazardous Drains",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 1,
      },
    ],
    ctos_qty: 4,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
    ],
    sce_code: "Client HSEMS",
    sce_name: "Client HSEMS",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 54,
      },
    ],
    ctos_qty: 2,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
    ],
    sce_code: "Client SCE",
    sce_name: "Client SCE",
    sce_status_code: 10,
    sce_status_color: "RED",
    sce_status_label: "Critical",
    tags_status_list: [
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 81,
      },
    ],
    ctos_qty: 25,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
    ],
    sce_code: "Client TIA",
    sce_name: "Client TIA plan",
    sce_status_code: 0,
    sce_status_color: "ORANGE",
    sce_status_label: "Degraded",
    tags_status_list: [
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
    ],
    ctos_qty: 21,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-01",
    sce_name: "Emergency Communications",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 833,
      },
    ],
    ctos_qty: 9,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
    ],
    sce_code: "DC-05",
    sce_name: "Emergency Depressurization (Blowdown) System",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 37,
      },
    ],
    ctos_qty: 6,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-04",
    sce_name: "Emergency Escape Lighting",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 962,
      },
    ],
    ctos_qty: 6,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-03",
    sce_name: "Emergency Power",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 4,
      },
    ],
    ctos_qty: 3,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "DC-04",
    sce_name: "Emergency Shutdown System",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 237,
      },
    ],
    ctos_qty: 0,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-02",
    sce_name: "Escape and Evacuation Routes",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 93,
      },
    ],
    ctos_qty: 4,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
    ],
    sce_code: "DC-03",
    sce_name: "Fire and Gas Detection",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 778,
      },
    ],
    ctos_qty: 1,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
    ],
    sce_code: "DC-07",
    sce_name: "Ignition Control",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 28,
      },
    ],
    ctos_qty: 8,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
    ],
    sce_code: "DC-01",
    sce_name: "Pressure Relief",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 170,
      },
    ],
    ctos_qty: 9,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-05",
    sce_name: "Temporary Refuge",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 2,
      },
    ],
    ctos_qty: 10,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
    ],
    sce_code: "DC-02",
    sce_name: "Vent and Flare System",
    sce_status_code: 0,
    sce_status_color: "ORANGE",
    sce_status_label: "Degraded",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 40,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 4,
      },
    ],
    ctos_qty: 4,
  },
];

export const orderBySceDesc: SceStatusList[] = [
  {
    linked_mahs_list: [
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
    ],
    sce_code: "DC-02",
    sce_name: "Vent and Flare System",
    sce_status_code: 0,
    sce_status_color: "ORANGE",
    sce_status_label: "Degraded",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 40,
      },
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 4,
      },
    ],
    ctos_qty: 4,
    sce_function: "",
    sce_barrier_name: "",
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-05",
    sce_name: "Temporary Refuge",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 2,
      },
    ],
    ctos_qty: 10,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
    ],
    sce_code: "DC-01",
    sce_name: "Pressure Relief",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 170,
      },
    ],
    ctos_qty: 9,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
    ],
    sce_code: "DC-07",
    sce_name: "Ignition Control",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 28,
      },
    ],
    ctos_qty: 8,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
    ],
    sce_code: "DC-03",
    sce_name: "Fire and Gas Detection",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 778,
      },
    ],
    ctos_qty: 1,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-02",
    sce_name: "Escape and Evacuation Routes",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 93,
      },
    ],
    ctos_qty: 4,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "DC-04",
    sce_name: "Emergency Shutdown System",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 237,
      },
    ],
    ctos_qty: 0,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-03",
    sce_name: "Emergency Power",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 4,
      },
    ],
    ctos_qty: 3,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-04",
    sce_name: "Emergency Escape Lighting",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 962,
      },
    ],
    ctos_qty: 6,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
    ],
    sce_code: "DC-05",
    sce_name: "Emergency Depressurization (Blowdown) System",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 37,
      },
    ],
    ctos_qty: 6,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-03a",
        code: "description MAH-03a",
      },
      {
        name: "MAH-03c",
        code: "description MAH-03c",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04b",
        code: "description MAH-04b",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-04g",
        code: "description MAH-04g",
      },
      {
        name: "MAH-05a",
        code: "description MAH-05a",
      },
      {
        name: "MAH-05b",
        code: "description MAH-05b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-06c",
        code: "description MAH-06c",
      },
      {
        name: "MAH-06d",
        code: "description MAH-06d",
      },
      {
        name: "MAH-06e",
        code: "description MAH-06e",
      },
      {
        name: "MAH-06f",
        code: "description MAH-06f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
      {
        name: "MAH-09a",
        code: "description MAH-09a",
      },
      {
        name: "MAH-09b",
        code: "description MAH-09b",
      },
    ],
    sce_code: "ER-01",
    sce_name: "Emergency Communications",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 833,
      },
    ],
    ctos_qty: 9,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
    ],
    sce_code: "Client TIA",
    sce_name: "Client TIA plan",
    sce_status_code: 0,
    sce_status_color: "ORANGE",
    sce_status_label: "Degraded",
    tags_status_list: [
      {
        tag_status_code: 0,
        tag_status_color: "ORANGE",
        tag_status_label: "Degraded",
        tags_qty: 13,
      },
    ],
    ctos_qty: 21,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
    ],
    sce_code: "Client SCE",
    sce_name: "Client SCE",
    sce_status_code: 10,
    sce_status_color: "RED",
    sce_status_label: "Critical",
    tags_status_list: [
      {
        tag_status_code: 10,
        tag_status_color: "RED",
        tag_status_label: "Critical",
        tags_qty: 81,
      },
    ],
    ctos_qty: 25,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-01a(S)",
        code: "description MAH-01a(S)",
      },
      {
        name: "MAH-01b(S)",
        code: "description MAH-01b(S)",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-04f",
        code: "description MAH-04f",
      },
      {
        name: "MAH-07a",
        code: "description MAH-07a",
      },
      {
        name: "MAH-08a",
        code: "description MAH-08a",
      },
    ],
    sce_code: "Client HSEMS",
    sce_name: "Client HSEMS",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 54,
      },
    ],
    ctos_qty: 2,
  },
  {
    sce_function: "",
    sce_barrier_name: "",
    linked_mahs_list: [
      {
        name: "MAH-02b",
        code: "description MAH-02b",
      },
      {
        name: "MAH-04a",
        code: "description MAH-04a",
      },
      {
        name: "MAH-04c",
        code: "description MAH-04c",
      },
      {
        name: "MAH-04d",
        code: "description MAH-04d",
      },
      {
        name: "MAH-04e",
        code: "description MAH-04e",
      },
      {
        name: "MAH-06a",
        code: "description MAH-06a",
      },
      {
        name: "MAH-06b",
        code: "description MAH-06b",
      },
    ],
    sce_code: "DC-06",
    sce_name: "Bunding and Open Hazardous Drains",
    sce_status_code: -1,
    sce_status_color: "GREEN",
    sce_status_label: "Healthy",
    tags_status_list: [
      {
        tag_status_code: -1,
        tag_status_color: "GREEN",
        tag_status_label: "Healthy",
        tags_qty: 1,
      },
    ],
    ctos_qty: 4,
  },
];

export const mockOrderByDueDateAsc: WonosStatusResponse[] = [
  {
    maint_class: "",
    due_date: "2020-12-19 00:00:00",
    job_code: "-",
    job_description: "SER - RACK 3500 CONF MOB FSR OFFSHORE1",
    job_status_code: 0,
    job_status_color: "ORANGE",
    linked_mahs_list: [
      {
        code: "MAH-02b",
        name: "description MAH-02b",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["PR-08"],
    linked_tags_list: ["CBA-2110A-1S"],
    manual_changes: true,
    revision_request_qty: 0,
    work_order_number: "000004064321",
    work_order_type: "Corrective",
    priority: null,
    effect: "1",
    system: "SAP",
  },
  {
    maint_class: "",
    due_date: "2020-12-19 00:00:00",
    job_code: "-",
    job_description: "SER - RACK 3500 CONF MOB FSR OFFSHORE2",
    job_status_code: 0,
    job_status_color: "ORANGE",
    linked_mahs_list: [
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
      {
        name: "description MAH-03b",
        code: "MAH-03b",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["PR-08"],
    linked_tags_list: ["CBA-2110A-1S"],
    manual_changes: true,
    revision_request_qty: 0,
    work_order_number: "000004064321",
    work_order_type: "Corrective",
    system: "SAP",
    priority: null,
    effect: "1",
  },
  {
    maint_class: "",
    due_date: "2021-01-07",
    job_code: "INS1103",
    job_description: "INSP OF TRANSMITTER",
    job_status_code: -1,
    job_status_color: "GREEN",
    linked_mahs_list: [
      {
        name: "description MAH-01a(S)",
        code: "MAH-01a(S)",
      },
      {
        name: "description MAH-01b(S)",
        code: "MAH-01b(S)",
      },
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
      {
        name: "description MAH-03a",
        code: "MAH-03a",
      },
      {
        name: "description MAH-03c",
        code: "MAH-03c",
      },
      {
        name: "description MAH-04a",
        code: "MAH-04a",
      },
      {
        name: "description MAH-04b",
        code: "MAH-04b",
      },
      {
        name: "description MAH-04c",
        code: "MAH-04c",
      },
      {
        name: "description MAH-04d",
        code: "MAH-04d",
      },
      {
        name: "description MAH-04e",
        code: "MAH-04e",
      },
      {
        name: "description MAH-04g",
        code: "MAH-04g",
      },
      {
        name: "description MAH-05a",
        code: "MAH-05a",
      },
      {
        name: "description MAH-05b",
        code: "MAH-05b",
      },
      {
        name: "description MAH-06a",
        code: "MAH-06a",
      },
      {
        name: "description MAH-06b",
        code: "MAH-06b",
      },
      {
        name: "description MAH-06c",
        code: "MAH-06c",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["DC-04"],
    linked_tags_list: ["LIT-1125-01-2P", "TIT-1120A-02-2P", "TIT-1120B-02-2P"],
    manual_changes: false,
    revision_request_qty: 0,
    work_order_number: "000004338586",
    work_order_type: "Preventive",
    system: "SAP",
    priority: null,
    effect: "1",
  },
  {
    maint_class: "",
    due_date: "2022-01-28",
    job_code: "CFT1724",
    job_description: "SART INSP AND TEST",
    job_status_code: -1,
    job_status_color: "GREEN",
    linked_mahs_list: [
      {
        name: "description MAH-01a(S)",
        code: "MAH-01a(S)",
      },
      {
        name: "description MAH-01b(S)",
        code: "MAH-01b(S)",
      },
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
      {
        name: "description MAH-03a",
        code: "MAH-03a",
      },
      {
        name: "description MAH-03c",
        code: "MAH-03c",
      },
      {
        name: "description MAH-04a",
        code: "MAH-04a",
      },
      {
        name: "description MAH-04b",
        code: "MAH-04b",
      },
      {
        name: "description MAH-04c",
        code: "MAH-04c",
      },
      {
        name: "description MAH-04d",
        code: "MAH-04d",
      },
      {
        name: "description MAH-04e",
        code: "MAH-04e",
      },
      {
        name: "description MAH-04f",
        code: "MAH-04f",
      },
      {
        name: "description MAH-04g",
        code: "MAH-04g",
      },
      {
        name: "description MAH-06c",
        code: "MAH-06c",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["ER-07"],
    linked_tags_list: ["SB-5005A-MD"],
    manual_changes: false,
    revision_request_qty: 0,
    work_order_number: "000004516964",
    work_order_type: "Preventive",
    system: "SAP",
    priority: null,
    effect: "1",
  },
];

export const orderByDueDateDesc: WonosStatusResponse[] = [
  {
    maint_class: "",
    due_date: "2022-01-28",
    job_code: "CFT1724",
    job_description: "SART INSP AND TEST",
    job_status_code: -1,
    job_status_color: "GREEN",
    linked_mahs_list: [
      {
        name: "description MAH-01a(S)",
        code: "MAH-01a(S)",
      },
      {
        name: "description MAH-01b(S)",
        code: "MAH-01b(S)",
      },
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
      {
        name: "description MAH-03a",
        code: "MAH-03a",
      },
      {
        name: "description MAH-03c",
        code: "MAH-03c",
      },
      {
        name: "description MAH-04a",
        code: "MAH-04a",
      },
      {
        name: "description MAH-04b",
        code: "MAH-04b",
      },
      {
        name: "description MAH-04c",
        code: "MAH-04c",
      },
      {
        name: "description MAH-04d",
        code: "MAH-04d",
      },
      {
        name: "description MAH-04e",
        code: "MAH-04e",
      },
      {
        name: "description MAH-04f",
        code: "MAH-04f",
      },
      {
        name: "description MAH-04g",
        code: "MAH-04g",
      },
      {
        name: "description MAH-06c",
        code: "MAH-06c",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["ER-07"],
    linked_tags_list: ["SB-5005A-MD"],
    manual_changes: false,
    revision_request_qty: 0,
    work_order_number: "000004516964",
    work_order_type: "Preventive",
    system: "SAP",
    priority: null,
    effect: "1",
  },
  {
    maint_class: "",
    due_date: "2021-01-07",
    job_code: "INS1103",
    job_description: "INSP OF TRANSMITTER",
    job_status_code: -1,
    job_status_color: "GREEN",
    linked_mahs_list: [
      {
        name: "description MAH-01a(S)",
        code: "MAH-01a(S)",
      },
      {
        name: "description MAH-01b(S)",
        code: "MAH-01b(S)",
      },
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
      {
        name: "description MAH-03a",
        code: "MAH-03a",
      },
      {
        name: "description MAH-03c",
        code: "MAH-03c",
      },
      {
        name: "description MAH-04a",
        code: "MAH-04a",
      },
      {
        name: "description MAH-04b",
        code: "MAH-04b",
      },
      {
        name: "description MAH-04c",
        code: "MAH-04c",
      },
      {
        name: "description MAH-04d",
        code: "MAH-04d",
      },
      {
        name: "description MAH-04e",
        code: "MAH-04e",
      },
      {
        name: "description MAH-04g",
        code: "MAH-04g",
      },
      {
        name: "description MAH-05a",
        code: "MAH-05a",
      },
      {
        name: "description MAH-05b",
        code: "MAH-05b",
      },
      {
        name: "description MAH-06a",
        code: "MAH-06a",
      },
      {
        name: "description MAH-06b",
        code: "MAH-06b",
      },
      {
        name: "description MAH-06c",
        code: "MAH-06c",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["DC-04"],
    linked_tags_list: ["LIT-1125-01-2P", "TIT-1120A-02-2P", "TIT-1120B-02-2P"],
    manual_changes: false,
    revision_request_qty: 0,
    work_order_number: "000004338586",
    work_order_type: "Preventive",
    system: "SAP",
    priority: null,
    effect: "1",
  },
  {
    maint_class: "",
    due_date: "2020-12-19 00:00:00",
    job_code: "-",
    job_description: "SER - RACK 3500 CONF MOB FSR OFFSHORE1",
    job_status_code: 0,
    job_status_color: "ORANGE",
    linked_mahs_list: [
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["PR-08"],
    linked_tags_list: ["CBA-2110A-1S"],
    manual_changes: true,
    revision_request_qty: 0,
    work_order_number: "000004064321",
    work_order_type: "Corrective",
    system: "SAP",
    priority: null,
    effect: "1",
  },
  {
    maint_class: "",
    due_date: "2020-12-19 00:00:00",
    job_code: "-",
    job_description: "SER - RACK 3500 CONF MOB FSR OFFSHORE2",
    job_status_code: 0,
    job_status_color: "ORANGE",
    linked_mahs_list: [
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
      {
        name: "description MAH-03b",
        code: "MAH-03b",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["PR-08"],
    linked_tags_list: ["CBA-2110A-1S"],
    manual_changes: true,
    revision_request_qty: 0,
    work_order_number: "000004064321",
    work_order_type: "Corrective",
    system: "SAP",
    priority: null,
    effect: "1",
  },
];

export const orderByDueDateWithNullDateDesc: WonosStatusResponse[] = [
  {
    maint_class: "",
    due_date: "2022-01-28",
    job_code: "CFT1724",
    job_description: "SART INSP AND TEST",
    job_status_code: -1,
    job_status_color: "GREEN",
    linked_mahs_list: [
      {
        name: "description MAH-01a(S)",
        code: "MAH-01a(S)",
      },
      {
        name: "description MAH-01b(S)",
        code: "MAH-01b(S)",
      },
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
      {
        name: "description MAH-03a",
        code: "MAH-03a",
      },
      {
        name: "description MAH-03c",
        code: "MAH-03c",
      },
      {
        name: "description MAH-04a",
        code: "MAH-04a",
      },
      {
        name: "description MAH-04b",
        code: "MAH-04b",
      },
      {
        name: "description MAH-04c",
        code: "MAH-04c",
      },
      {
        name: "description MAH-04d",
        code: "MAH-04d",
      },
      {
        name: "description MAH-04e",
        code: "MAH-04e",
      },
      {
        name: "description MAH-04f",
        code: "MAH-04f",
      },
      {
        name: "description MAH-04g",
        code: "MAH-04g",
      },
      {
        name: "description MAH-06c",
        code: "MAH-06c",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["ER-07"],
    linked_tags_list: ["SB-5005A-MD"],
    manual_changes: false,
    revision_request_qty: 0,
    work_order_number: "000004516964",
    work_order_type: "Preventive",
    system: "SAP",
    priority: null,
    effect: "1",
  },
  {
    maint_class: "",
    due_date: "2020-12-19 00:00:00",
    job_code: "-",
    job_description: "SER - RACK 3500 CONF MOB FSR OFFSHORE2",
    job_status_code: 0,
    job_status_color: "ORANGE",
    linked_mahs_list: [
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
      {
        name: "description MAH-03b",
        code: "MAH-03b",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["PR-08"],
    linked_tags_list: ["CBA-2110A-1S"],
    manual_changes: true,
    revision_request_qty: 0,
    work_order_number: "000004064321",
    work_order_type: "Corrective",
    system: "SAP",
    priority: null,
    effect: "1",
  },
  {
    maint_class: "",
    due_date: null as unknown as string,
    job_code: "-",
    job_description: "SER - RACK 3500 CONF MOB FSR OFFSHORE1",
    job_status_code: 0,
    job_status_color: "ORANGE",
    linked_mahs_list: [
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["PR-08"],
    linked_tags_list: ["CBA-2110A-1S"],
    manual_changes: true,
    revision_request_qty: 0,
    work_order_number: "000004064321",
    work_order_type: "Corrective",
    system: "SAP",
    priority: null,
    effect: "1",
  },
  {
    maint_class: "",
    due_date: "-",
    job_code: "INS1103",
    job_description: "INSP OF TRANSMITTER",
    job_status_code: -1,
    job_status_color: "GREEN",
    linked_mahs_list: [
      {
        name: "description MAH-01a(S)",
        code: "MAH-01a(S)",
      },
      {
        name: "description MAH-01b(S)",
        code: "MAH-01b(S)",
      },
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
      {
        name: "description MAH-03a",
        code: "MAH-03a",
      },
      {
        name: "description MAH-03c",
        code: "MAH-03c",
      },
      {
        name: "description MAH-04a",
        code: "MAH-04a",
      },
      {
        name: "description MAH-04b",
        code: "MAH-04b",
      },
      {
        name: "description MAH-04c",
        code: "MAH-04c",
      },
      {
        name: "description MAH-04d",
        code: "MAH-04d",
      },
      {
        name: "description MAH-04e",
        code: "MAH-04e",
      },
      {
        name: "description MAH-04g",
        code: "MAH-04g",
      },
      {
        name: "description MAH-05a",
        code: "MAH-05a",
      },
      {
        name: "description MAH-05b",
        code: "MAH-05b",
      },
      {
        name: "description MAH-06a",
        code: "MAH-06a",
      },
      {
        name: "description MAH-06b",
        code: "MAH-06b",
      },
      {
        name: "description MAH-06c",
        code: "MAH-06c",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["DC-04"],
    linked_tags_list: ["LIT-1125-01-2P", "TIT-1120A-02-2P", "TIT-1120B-02-2P"],
    manual_changes: false,
    revision_request_qty: 0,
    work_order_number: "000004338586",
    work_order_type: "Preventive",
    system: "SAP",
    priority: null,
    effect: "1",
  },
];

export const orderByDueDateWithNullDateAsc: WonosStatusResponse[] = [
  {
    maint_class: "",
    due_date: null as unknown as string,
    job_code: "-",
    job_description: "SER - RACK 3500 CONF MOB FSR OFFSHORE1",
    job_status_code: 0,
    job_status_color: "ORANGE",
    linked_mahs_list: [
      {
        code: "MAH-02b",
        name: "description MAH-02b",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["PR-08"],
    linked_tags_list: ["CBA-2110A-1S"],
    manual_changes: true,
    revision_request_qty: 0,
    work_order_number: "000004064321",
    work_order_type: "Corrective",
    priority: null,
    effect: "1",
    system: "SAP",
  },
  {
    maint_class: "",
    due_date: "-",
    job_code: "INS1103",
    job_description: "INSP OF TRANSMITTER",
    job_status_code: -1,
    job_status_color: "GREEN",
    linked_mahs_list: [
      {
        name: "description MAH-01a(S)",
        code: "MAH-01a(S)",
      },
      {
        name: "description MAH-01b(S)",
        code: "MAH-01b(S)",
      },
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
      {
        name: "description MAH-03a",
        code: "MAH-03a",
      },
      {
        name: "description MAH-03c",
        code: "MAH-03c",
      },
      {
        name: "description MAH-04a",
        code: "MAH-04a",
      },
      {
        name: "description MAH-04b",
        code: "MAH-04b",
      },
      {
        name: "description MAH-04c",
        code: "MAH-04c",
      },
      {
        name: "description MAH-04d",
        code: "MAH-04d",
      },
      {
        name: "description MAH-04e",
        code: "MAH-04e",
      },
      {
        name: "description MAH-04g",
        code: "MAH-04g",
      },
      {
        name: "description MAH-05a",
        code: "MAH-05a",
      },
      {
        name: "description MAH-05b",
        code: "MAH-05b",
      },
      {
        name: "description MAH-06a",
        code: "MAH-06a",
      },
      {
        name: "description MAH-06b",
        code: "MAH-06b",
      },
      {
        name: "description MAH-06c",
        code: "MAH-06c",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["DC-04"],
    linked_tags_list: ["LIT-1125-01-2P", "TIT-1120A-02-2P", "TIT-1120B-02-2P"],
    manual_changes: false,
    revision_request_qty: 0,
    work_order_number: "000004338586",
    work_order_type: "Preventive",
    system: "SAP",
    priority: null,
    effect: "1",
  },
  {
    maint_class: "",
    due_date: "2020-12-19 00:00:00",
    job_code: "-",
    job_description: "SER - RACK 3500 CONF MOB FSR OFFSHORE2",
    job_status_code: 0,
    job_status_color: "ORANGE",
    linked_mahs_list: [
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
      {
        name: "description MAH-03b",
        code: "MAH-03b",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["PR-08"],
    linked_tags_list: ["CBA-2110A-1S"],
    manual_changes: true,
    revision_request_qty: 0,
    work_order_number: "000004064321",
    work_order_type: "Corrective",
    system: "SAP",
    priority: null,
    effect: "1",
  },
  {
    maint_class: "",
    due_date: "2022-01-28",
    job_code: "CFT1724",
    job_description: "SART INSP AND TEST",
    job_status_code: -1,
    job_status_color: "GREEN",
    linked_mahs_list: [
      {
        name: "description MAH-01a(S)",
        code: "MAH-01a(S)",
      },
      {
        name: "description MAH-01b(S)",
        code: "MAH-01b(S)",
      },
      {
        name: "description MAH-02b",
        code: "MAH-02b",
      },
      {
        name: "description MAH-03a",
        code: "MAH-03a",
      },
      {
        name: "description MAH-03c",
        code: "MAH-03c",
      },
      {
        name: "description MAH-04a",
        code: "MAH-04a",
      },
      {
        name: "description MAH-04b",
        code: "MAH-04b",
      },
      {
        name: "description MAH-04c",
        code: "MAH-04c",
      },
      {
        name: "description MAH-04d",
        code: "MAH-04d",
      },
      {
        name: "description MAH-04e",
        code: "MAH-04e",
      },
      {
        name: "description MAH-04f",
        code: "MAH-04f",
      },
      {
        name: "description MAH-04g",
        code: "MAH-04g",
      },
      {
        name: "description MAH-06c",
        code: "MAH-06c",
      },
    ],
    linked_barriers_list: [],
    tag_type: "SCE-ONLY",
    linked_sces_list: ["ER-07"],
    linked_tags_list: ["SB-5005A-MD"],
    manual_changes: false,
    revision_request_qty: 0,
    work_order_number: "000004516964",
    work_order_type: "Preventive",
    system: "SAP",
    priority: null,
    effect: "1",
  },
];

export const orderByCurrentStepAsc: TagsResponse[] = [
  {
    tag_code: "TAG-001",
    tag_name: "Tag Name 001",
    cto: {
      current_step: 1,
      cto_number: "CTO-001",
      cto_status: CtoStatus.UNDER_EVALUATION,
    },
    barriers: [],
    ctos: [],
    mahs: [],
    sces: [],
    moc_number: null,
    moc_status: null,
    redundant_tags: 0,
    tag_status_code: -1,
    sensor: {
      status: "HEALTHY",
      updated_at: null,
    },
    wos: {
      status: "HEALTHY",
      open_wos: null,
    },
    tag_family_code: null,
    tag_family_status_code: -1,
    tag_ref_drawing: "",
    tag_type: "SCE-ONLY",
    open_wos: [],
    hcs: [],
  },
  {
    tag_code: "TAG-002",
    tag_name: "Tag Name 002",
    cto: {
      current_step: 2,
      cto_number: "CTO-002",
      cto_status: CtoStatus.UNDER_EVALUATION,
    },
    barriers: [],
    ctos: [],
    mahs: [],
    sces: [],
    moc_number: null,
    moc_status: null,
    redundant_tags: 0,
    tag_status_code: -1,
    sensor: {
      status: "HEALTHY",
      updated_at: null,
    },
    wos: {
      status: "HEALTHY",
      open_wos: null,
    },
    tag_family_code: null,
    tag_family_status_code: -1,
    tag_ref_drawing: "",
    tag_type: "SCE-ONLY",
    open_wos: [],
    hcs: [],
  },
  {
    tag_code: "TAG-003",
    tag_name: "Tag Name 003",
    cto: {
      current_step: 3,
      cto_number: "CTO-003",
      cto_status: CtoStatus.UNDER_EVALUATION,
    },
    barriers: [],
    ctos: [],
    mahs: [],
    sces: [],
    moc_number: null,
    moc_status: null,
    redundant_tags: 0,
    tag_status_code: -1,
    sensor: {
      status: "HEALTHY",
      updated_at: null,
    },
    wos: {
      status: "HEALTHY",
      open_wos: null,
    },
    tag_family_code: null,
    tag_family_status_code: -1,
    tag_ref_drawing: "",
    tag_type: "SCE-ONLY",
    open_wos: [],
    hcs: [],
  },
];

export const orderByCurrentStepDesc: TagsResponse[] = [
  {
    tag_code: "TAG-003",
    tag_name: "Tag Name 003",
    cto: {
      current_step: 3,
      cto_number: "CTO-003",
      cto_status: CtoStatus.UNDER_EVALUATION,
    },
    barriers: [],
    ctos: [],
    mahs: [],
    sces: [],
    moc_number: null,
    moc_status: null,
    redundant_tags: 0,
    tag_status_code: -1,
    sensor: {
      status: "HEALTHY",
      updated_at: null,
    },
    wos: {
      status: "HEALTHY",
      open_wos: null,
    },
    tag_family_code: null,
    tag_family_status_code: -1,
    tag_ref_drawing: "",
    tag_type: "SCE-ONLY",
    open_wos: [],
    hcs: [],
  },
  {
    tag_code: "TAG-002",
    tag_name: "Tag Name 002",
    cto: {
      current_step: 2,
      cto_number: "CTO-002",
      cto_status: CtoStatus.UNDER_EVALUATION,
    },
    barriers: [],
    ctos: [],
    mahs: [],
    sces: [],
    moc_number: null,
    moc_status: null,
    redundant_tags: 0,
    tag_status_code: -1,
    sensor: {
      status: "HEALTHY",
      updated_at: null,
    },
    wos: {
      status: "HEALTHY",
      open_wos: null,
    },
    tag_family_code: null,
    tag_family_status_code: -1,
    tag_ref_drawing: "",
    tag_type: "SCE-ONLY",
    open_wos: [],
    hcs: [],
  },
  {
    tag_code: "TAG-001",
    tag_name: "Tag Name 001",
    cto: {
      current_step: 1,
      cto_number: "CTO-001",
      cto_status: CtoStatus.UNDER_EVALUATION,
    },
    barriers: [],
    ctos: [],
    mahs: [],
    sces: [],
    moc_number: null,
    moc_status: null,
    redundant_tags: 0,
    tag_status_code: -1,
    sensor: {
      status: "HEALTHY",
      updated_at: null,
    },
    wos: {
      status: "HEALTHY",
      open_wos: null,
    },
    tag_family_code: null,
    tag_family_status_code: -1,
    tag_ref_drawing: "",
    tag_type: "SCE-ONLY",
    open_wos: [],
    hcs: [],
  },
];

